import { IncidentIndicator } from "~/components/IncidentBanner/useIncidentBanner";
import { useColorMode } from "~/providers/color-mode";
import { useTheme } from "@mui/material";

export const useIncidentBannerColors = (
  incidentIndicator: IncidentIndicator | undefined,
) => {
  const { mode } = useColorMode();
  const theme = useTheme();

  let bgColor: string,
    borderColor: string,
    messageColor: string,
    iconActionLinkColor: string;

  switch (incidentIndicator) {
    case IncidentIndicator.CRITICAL:
      bgColor = (
        mode === "dark" ? theme.palette.error.dark : theme.palette.error.lighter
      ) as string;
      borderColor = theme.palette.error.main;
      messageColor = bgColor;
      iconActionLinkColor = (
        mode === "dark" ? theme.palette.error.lighter : theme.palette.error.dark
      ) as string;
      break;
    case IncidentIndicator.MAINTENANCE:
      bgColor = (
        mode === "dark"
          ? theme.palette.secondary.darker
          : theme.palette.secondary.lighter
      ) as string;
      borderColor = theme.palette.secondary.main;
      messageColor = bgColor;
      iconActionLinkColor = (
        mode === "dark"
          ? theme.palette.secondary.lighter
          : theme.palette.secondary.darker
      ) as string;
      break;
    default:
      bgColor =
        mode === "dark"
          ? theme.palette.warning.dark
          : theme.palette.warning.light;
      borderColor = theme.palette.warning.main;
      messageColor = theme.palette.warning.light;
      iconActionLinkColor =
        mode === "dark"
          ? theme.palette.warning.light
          : theme.palette.warning.dark;
      break;
  }

  return {
    borderTop: "solid",
    backgroundColor: bgColor,
    borderColor: borderColor,
    borderWidth: theme.spacing(0.5),
    ".MuiPaper-root": {
      backgroundColor: bgColor,
    },
    ".MuiAlert-message": {
      color: messageColor,
      fontSize: theme.typography.body1,
      fontWeight: 500,
    },
    ".MuiAlert-icon": {
      color: iconActionLinkColor,
      pt: "9px",
    },
    ".MuiAlert-action": {
      color: iconActionLinkColor,
    },
    ".MuiLink-root": {
      color: iconActionLinkColor,
    },
  };
};
